/**
 * Select Options Utility
 */

import { SelectOptions } from '../types';

/**
 * Returns menu options for a select field based on selection name.
 *
 * @param selection - The parameter name to look up options for
 * @param selectOptions - Array of SelectOptions to search
 * @returns Array of option strings, or empty array if not found
 *
 * @example
 * const options = getSelectOptions('program_type', selectOptions);
 * // Returns ['Option 1', 'Option 2', ...]
 */
export const getSelectOptions = (
  selection: string,
  selectOptions: SelectOptions[],
): string[] => {
  const option = selectOptions.find((opt) => opt.selection === selection);
  return option?.menuOptions ?? [];
};
